import { render, staticRenderFns } from "./WaitDialog.vue?vue&type=template&id=5b4bee03&scoped=true"
import script from "./WaitDialog.vue?vue&type=script&lang=js"
export * from "./WaitDialog.vue?vue&type=script&lang=js"
import style0 from "./WaitDialog.vue?vue&type=style&index=0&id=5b4bee03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bee03",
  null
  
)

export default component.exports